import type { ReactNode } from "react";
import styles from "./SlideHeading.module.scss";

export function SlideHeading({ children }: { children: ReactNode }) {
  return <h2 className={styles.heading}>{children}</h2>;
}
